var SortString = /** @class */ (function () {
    function SortString() {
        this.strLength = 20;
        this.strFrom = 48;
        this.strTo = 90;
    }
    SortString.prototype.generate = function () {
        var i, str = "";
        for (i = 0; i < this.strLength / 3; i++) {
            str += String.fromCharCode(this.strFrom);
        }
        while (str.length < this.strLength) {
            str += String.fromCharCode(this.strFrom + Math.floor(Math.random() * (this.strTo - this.strFrom + 1)));
        }
        return str;
    };
    SortString.prototype.before = function (str) {
        var step = this._step();
        if (this.compare(str, step) > 0) {
            return this._minus(str, step);
        }
        else if (this.compare(str, String.fromCharCode(this.strTo)) > 0) {
            while (this.compare(str, step) < 0) {
                step = this._div2(step);
            }
            return this._minus(str, step);
        }
        else {
            return "";
        }
    };
    SortString.prototype.after = function (str) {
        return this._plus(str, this._step());
    };
    SortString.prototype.between = function (str1, str2) {
        var diff, min, rnd = "";
        if (this.compare(str1, str2) > 0) {
            diff = this._minus(str1, str2);
            min = str2;
        }
        else {
            diff = this._minus(str2, str1);
            min = str1;
        }
        diff = this._div2(diff);
        while (rnd.length < diff.length / 2) {
            rnd += String.fromCharCode(this.strFrom + Math.floor(Math.random() * (this.strTo - this.strFrom + 1)));
        }
        diff = this._plus(diff, rnd);
        return this._plus(diff, min);
    };
    SortString.prototype.compare = function (str1, str2) {
        var i, length, diff;
        if (!str1 || !str2) {
            return 0;
        }
        length = Math.max(str1.length, str2.length);
        for (i = 0; i < length; i++) {
            diff = (str1.charCodeAt(str1.length - length + i) || this.strFrom) - (str2.charCodeAt(str2.length - length + i) || this.strFrom);
            if (diff > 0) {
                return 1;
            }
            else if (diff < 0) {
                return -1;
            }
        }
        return 0;
    };
    SortString.prototype._plus = function (str1, str2) {
        var i, down, length, result = "", up = 0;
        length = Math.max(str1.length, str2.length);
        for (i = length - 1; i >= 0; i--) {
            up += (str1.charCodeAt(str1.length - length + i) || this.strFrom) - this.strFrom + (str2.charCodeAt(str2.length - length + i) || this.strFrom) - this.strFrom;
            down = up % (this.strTo - this.strFrom + 1);
            up = (up - down) / (this.strTo - this.strFrom + 1);
            result = String.fromCharCode(this.strFrom + down) + result;
        }
        if (up > 0) {
            result = String.fromCharCode(this.strFrom + up) + result;
        }
        return result;
    };
    SortString.prototype._minus = function (str1, str2) {
        var i, down, length, result = "", up = 0;
        length = Math.max(str1.length, str2.length);
        for (i = length - 1; i >= 0; i--) {
            down = (str1.charCodeAt(str1.length - length + i) || this.strFrom) - (str2.charCodeAt(str2.length - length + i) || this.strFrom) - up;
            if (down < 0) {
                up = 1;
                down = down + (this.strTo - this.strFrom + 1);
            }
            else {
                up = 0;
            }
            result = String.fromCharCode(this.strFrom + down) + result;
        }
        if (up > 0) {
            result = ""; // - 
        }
        return result;
    };
    SortString.prototype._div2 = function (str) {
        var i, down, restIdx, cnt = 0, num = 0, result = "";
        for (i = 0; i < str.length; i++) {
            if (num > 0 || (str.charCodeAt(i) - this.strFrom) > 0) {
                num = num * (this.strTo - this.strFrom + 1) + (str.charCodeAt(i) - this.strFrom);
                cnt++;
                if (cnt === 5) {
                    restIdx = i;
                    break;
                }
            }
        }
        num /= 2;
        while (num > 0) {
            down = num % (this.strTo - this.strFrom + 1);
            result = String.fromCharCode(down + this.strFrom) + result;
            num = Math.floor(num / (this.strTo - this.strFrom + 1));
        }
        if (restIdx < str.length) {
            result += str.substring(restIdx + 1);
        }
        return result;
    };
    SortString.prototype._step = function () {
        var i, str = "";
        for (i = 0; i < this.strLength / 2; i++) {
            str += String.fromCharCode(this.strFrom);
        }
        while (str.length < this.strLength) {
            str += String.fromCharCode(this.strFrom + Math.floor(Math.random() * (this.strTo - this.strFrom + 1)));
        }
        return str;
    };
    return SortString;
}());
/**
 * Class for generating sort strings
 *
 * @since v2.26.0
 * @category Sorting
 * @returns {void}
 * @example
 *  const sort = new SortOrderString();
 *  sort.generate() //Returns new sort string when there are no existing elements in list.
 *  sort.after('1234') //Returns a string that will be after the provided string
 *  sort.before('1234') // Returns a string that will be before the provided string
 *  sort.between('00456', '00356') // Returns string value between provided strings
 *
 *  //Compare strings use this to list of sort order strings.
 *  sort.compare('00456', '00456') => 0
 *  sort.compare('00456', '00457') => -1
 *  sort.compare('00456', '00455') => 1
 */
export { SortString };
